import React, { useEffect } from "react";
import { Box } from "@mui/material";
import AdminCarriers from "../adminCarrier/AdminCarrier";

interface ContentAreaProps {
  sidebarOpen: boolean;
  activeComponent: string;
}

const AdminContentArea: React.FC<ContentAreaProps> = ({
  sidebarOpen,
  activeComponent,
}) => {
  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          width: "100%",
          background:
            "linear-gradient(-45deg, #ee7752, #e73c7e, #23d5ab, #23a6d5)",
          backgroundSize: "400% 400%",
          animation: "gradientAnimation 20s ease infinite",
          display: "flex",
          p: 3,
        }}
      >
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            pt: 8,
            textAlign: "left",
            // ml: sidebarOpen ? "20px" : 0,
            transition: (theme) =>
              theme.transitions.create("margin", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
              }),
          }}
        >
          {activeComponent === "AdminCarriers" && <AdminCarriers />}
          {/* {activeComponent === "Rates" && <Rates />}
      {activeComponent === "BoxRates" && <BoxRates />}
      {activeComponent === "LongDistance" && <LongDistance />}
      {activeComponent === "Insurance" && <Insurance />}
      {activeComponent === "TravelTime" && <TravelTime />}
      {activeComponent === "TimeSlot" && <TimeSlot />}
      {activeComponent === "Stats" && <CarrierStats />}
      {activeComponent === "AIBot" && <AIBot />} */}
        </Box>
      </Box>
      <style>
        {`
          @keyframes gradientAnimation {
            0% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
            100% {
              background-position: 0% 50%;
            }
          }
        `}
      </style>
    </>
  );
};

export default AdminContentArea;
